import OpenProductTab from "./OpenProductTab";

export { OpenProductTab };
export default OpenProductTab;
